export default __webpack_public_path__ + "static/media/JoinTheAcrocalypse.56116746.png";